import React from "react";
import {
    useTable,
    useFilters,
    useSortBy,
    usePagination,
} from "react-table";
// import CssBaseline from "@material-ui/core/CssBaseline";
import MaUTable from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

// import Paginations from "components/Pagination/Pagination.js";
import { Pagination } from '@mui/material';
import classnames from "classnames";
// A great library for fuzzy filtering/sorting items
import { matchSorter } from "match-sorter";

import {
    FormGroup,
    // Input, 
    Row,
    Col
} from "reactstrap";


function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
}) {
    // const count = preFilteredRows.length;

    return (
        <input
            value={filterValue || ""}
            style={{ width: "80px", borderRadius: "15px", zIndex: 1 }}
            onChange={(e) => {
                setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
            }}
            placeholder={`Αναζήτηση`}
        />
    );
}

function fuzzyTextFilterFn(rows, id, filterValue) {
    return matchSorter(rows, filterValue, { keys: [(row) => row.values[id]] });
}


// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = (val) => !val;
// Our table component
function Table({ columns, data }) {
    // const [numberOfRows, setNumberOfRows] = React.useState(10);
    const [pageSelect, handlePageSelect] = React.useState(0);
    const filterTypes = React.useMemo(
        () => ({
            // Add a new fuzzyTextFilterFn filter type.
            fuzzyText: fuzzyTextFilterFn,
            // Or, override the default text filter to use
            // "startWith"
            text: (rows, id, filterValue) => {
                return rows.filter((row) => {
                    const rowValue = row.values[id];
                    return rowValue !== undefined
                        ? String(rowValue)
                            .toLowerCase()
                            .startsWith(String(filterValue).toLowerCase())
                        : true;
                });
            },
        }),
        []
    );
    const defaultColumn = React.useMemo(
        () => ({
            // Let's set up our default Filter UI
            Filter: DefaultColumnFilter,
        }),
        []
    );
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        state,
        visibleColumns,
        nextPage,
        pageOptions,
        pageCount,
        previousPage,
        canPreviousPage,
        canNextPage,
        setPageSize,
        gotoPage,
    } = useTable(
        {
            columns,
            data,
            defaultColumn, // Be sure to pass the defaultColumn options
            filterTypes,
            initialState: { pageSize: 5, pageIndex: 0 },
            autoResetPage: false
        },

        useFilters,

        useSortBy,
        usePagination
        // useGlobalFilter!
    );

    return (
        <>
            <div className="ReactTable -striped -highlight">
                <MaUTable {...getTableProps()} className="rt-table">
                    <TableHead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column, key) => (
                                    <th key={key}>
                                        <span
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                        >

                                            {column.render("Header")}
                                            <span>
                                                {column.isSorted
                                                    ? column.isSortedDesc
                                                        ? " 🔽"
                                                        : " 🔼"
                                                    : ""}
                                            </span>
                                        </span>
                                        <div>
                                            {column.canFilter ? column.render("Filter") : null}
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </TableHead>
                    <TableBody {...getTableBodyProps()} className="rt-tbody">
                        {page.map((row, i) => {
                            prepareRow(row);
                            return (
                                <TableRow
                                    {...row.getRowProps()}
                                    className={classnames(
                                        "rt-tr",
                                        { " -odd": i % 2 === 0 },
                                        { " -even": i % 2 === 1 }
                                    )}
                                >
                                    {row.cells.map((cell) => {
                                        return (
                                            <TableCell
                                                {...cell.getCellProps()}
                                                className="rt-td ml-1"
                                            >
                                                {cell.render("Cell")}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </MaUTable>
                <div>
                    <FormGroup row>
                        <Row>
                            <Col>
                                <br />
                                <Pagination
                                    count={pageCount}
                                    page={pageSelect + 1}
                                    color="primary"
                                    onChange={(event, value) => {
                                        gotoPage(value - 1);
                                        handlePageSelect(value - 1);
                                    }}

                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </div>
            </div>
            {/* <div>
        <pre>
          <code>{JSON.stringify(state.filters, null, 2)}</code>
        </pre>
      </div> */}
        </>
    );
}
// Define a custom filter filter function!
function filterGreaterThan(rows, id, filterValue) {
    return rows.filter((row) => {
        const rowValue = row.values[id];
        return rowValue >= filterValue;
    });
}
// This is an autoRemove method on the filter function that
// when given the new filter value and returns true, the filter
// will be automatically removed. Normally this is just an undefined
// check, but here, we want to remove the filter if it's not a number
filterGreaterThan.autoRemove = (val) => typeof val !== "number";
export default Table;
